export const decodePackageSocialSpendCommitment = (socialCommitment) => {
    return {
        created: new Date(socialCommitment.created),
        id: socialCommitment.package_social_spend_commitment_id,
        packageId: socialCommitment.contractor_package_id,
        projectId: socialCommitment.project_id,
        projectSocialSpendCommitmentId: socialCommitment.project_social_spend_commitment_id,
        targetDescription: socialCommitment.target_description,
        targetName: socialCommitment.target_type,
        targetValue: socialCommitment.target_value,
        targetValueRealised: socialCommitment.target_value_realised
    };
};
export const encodePackageSocialSpendCommitment = (socialCommitment) => {
    if (!socialCommitment.id) {
        throw new Error("No id supplied");
    }
    return {
        contractor_package_id: socialCommitment.packageId,
        created: socialCommitment.created,
        package_social_spend_commitment_id: socialCommitment.id,
        project_id: socialCommitment.projectId,
        project_social_spend_commitment_id: socialCommitment.projectSocialSpendCommitmentId,
        target_description: socialCommitment.targetDescription,
        target_type: socialCommitment.targetName,
        target_value: socialCommitment.targetValue,
        target_value_realised: socialCommitment.targetValueRealised
    };
};
